import type { FolderControllerGetFolderWithContentsPathParamsTypeEnum } from '@proposify/document-service-api-client';
import { documentServiceClient, documentServiceSchemas, type FolderWithContentsResponse } from '@proposify/document-service-api-client';
import { trackError } from '@proposify/frontend-observability';
import { getDocumentServiceSchemaClient } from 'services/api/client';
import type { ContentFolder, ContentFolderType } from './entities';

const folderMapper = (folder: FolderWithContentsResponse): ContentFolder => {
  const contents = folder.contents ?? [];
  const subfolders = folder.subfolders ?? [];
  return {
    id: folder.id,
    name: folder.name,
    type: folder.type,
    createdAt: new Date(folder.createdAt),
    updatedAt: new Date(folder.updatedAt),
    contents: contents.map((content) => ({
      id: content.id,
      name: content.name,
      type: content.type,
      parentFolderId: content.folderId ?? undefined,
      createdAt: new Date(content.createdAt),
      updatedAt: new Date(content.updatedAt),
      deletedAt: content.deletedAt ? new Date(content.deletedAt) : undefined,
      imageUrl: content.imageUrl,
    })),
    subfolders: subfolders.map(folderMapper),
  };
};

async function listFolders({ type }: { type: ContentFolderType }): Promise<ContentFolder> {
  const data = await documentServiceClient.folderGetFolderWithContents(
    type as FolderControllerGetFolderWithContentsPathParamsTypeEnum,
    undefined,
    getDocumentServiceSchemaClient()
  );

  const parsedResponse = documentServiceSchemas.folderWithContentsResponseSchema.safeParse(data);
  if (!parsedResponse.success) {
    trackError('listFolders response schema validation failed', {
      message: parsedResponse.error.message,
      stack: parsedResponse.error.stack,
      payload: JSON.stringify(data),
      errorFrom: 'editor-remote',
      cause: 'document-service folderGetFolderWithContents response schema validation failed',
    });
  }

  return folderMapper(data);
}

export const DocumentServiceFoldersRepository = {
  listFolders,
};
